/* AdminLayout — page shell for the admin panel.
   - Single H1 ("Admin Panel") per page
   - <nav aria-label="Admin"> wraps the tablist (landmark)
   - Skip link points at the active panel
   - Action bar slot lives in the header for primary actions per tab
*/
import React from "react";
import { P } from "../shared/constants";
import AdminTabs, { TABS } from "./AdminTabs";
var E = React.createElement;

function panelLabel(active){
  var t = TABS.find(function(x){return x.id===active});
  return t ? t.label : "Admin";
}

export default function AdminLayout(props){
  var active = props.active || "overview";
  var panelId = "admin-panel-"+active;
  var tabId   = "admin-tab-"+active;
  return E("div",{className:"adminLayout",
    style:{display:"flex",flexDirection:"column",gap:16,maxWidth:1400,margin:"0 auto"}},
    /* Skip link inside the admin layout, targets the active panel. Falls
       behind the top skip link by tab order so general "skip to main"
       still wins on first focus. */
    E("a",{href:"#"+panelId, className:"skip",
      style:{position:"absolute",left:8,top:-100,padding:"8px 14px",
        background:P.pri,color:"#fff",borderRadius:"0 0 8px 8px",
        fontWeight:700,zIndex:200,textDecoration:"none"}},
      "Skip to admin content"),
    E("header",{
      style:{display:"flex",alignItems:"flex-end",justifyContent:"space-between",
        flexWrap:"wrap",gap:12,paddingBottom:8,borderBottom:"1px solid "+P.bdr}},
      E("div",null,
        E("h1",{style:{margin:0,fontSize:24,fontWeight:900,color:P.slate,
          letterSpacing:"-0.01em"}},"Admin Panel"),
        E("p",{style:{margin:"4px 0 0",fontSize:12,color:P.slateM}},
          panelLabel(active))),
      props.actionBar ? E("div",{style:{display:"flex",gap:8,flexWrap:"wrap"}}, props.actionBar) : null
    ),
    E("nav",{"aria-label":"Admin"},
      E(AdminTabs,{active:active, onChange:props.onChange})),
    E("section",{
      id:panelId,
      role:"tabpanel",
      "aria-labelledby":tabId,
      tabIndex:0,
      style:{outlineOffset:4,paddingTop:8}
    }, props.children)
  );
}
